"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginTemplates = void 0;
var React = require("react");
var PluginTemplates = /** @class */ (function () {
    function PluginTemplates() {
    }
    PluginTemplates.prototype.renderBackLink = function (buttonName, isTop, link) {
        if (link) {
            return (React.createElement("div", { className: "".concat(isTop ? "back-link-top" : "back-link-bottom") },
                React.createElement("button", { type: "button", className: "btn btn-back-link", onClick: function () { window.location.href = link; } }, buttonName)));
        }
        return (React.createElement("div", { className: "".concat(isTop ? "back-link-top" : "back-link-bottom") },
            React.createElement("a", { onClick: this.goBack },
                React.createElement("button", { type: "button", role: "link", className: "btn btn-back-link" }, buttonName))));
    };
    PluginTemplates.prototype.goBack = function (event) {
        event.target.href = window.history.back();
    };
    return PluginTemplates;
}());
exports.PluginTemplates = PluginTemplates;
//# sourceMappingURL=PluginTemplates.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/components/PluginTemplates.js
// module id = 2522
// module chunks = 0